import { render, staticRenderFns } from "./DeactivateWallet.vue?vue&type=template&id=52c42f04"
import script from "./DeactivateWallet.vue?vue&type=script&lang=js"
export * from "./DeactivateWallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports